import Fetch from "../script/Fetch";
import { SezioneAggiuntiva } from "orser-model/SezioneAggiuntiva";

export class SezioneAggiuntivaService {
    async getSezioneAggiuntivaListByArticoloId(articoloId: any) {
        const response = await Fetch.doFetch(`/articolo/${articoloId}/sezioniaggiuntive`, {
            method: "GET"
        });
        const data = await response.json();

        if (Array.isArray(data)) {
            return data.map(SezioneAggiuntiva.fromJson);
        }

        throw new Error("Errore durante il recupero delle sezioni aggiuntive");
    }

    async getSezioneAggiuntivaList(ristoranteId: string) {
        const response = await Fetch.doFetch(`/ristorante/${ristoranteId}/sezioniaggiuntive`, {
            method: "GET"
        });
        const data = await response.json();

        if (Array.isArray(data)) {
            return data.map(SezioneAggiuntiva.fromJson);
        }

        throw new Error("Errore durante il recupero delle sezioni aggiuntive");
    }

    async saveSezioneAggiuntiva(ristoranteId: string, sezioneAggiuntiva: SezioneAggiuntiva) {

        const response = await Fetch.doFetch(`/ristorante/${ristoranteId}/sezioniaggiuntive`, {
            method: "POST",
            body: sezioneAggiuntiva
        });

        if (response.status !== 200) {
            throw new Error("Errore durante il salvataggio della sezione aggiuntiva");
        }

        return await response.json();
    }
}